import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/CashFlow-Payments.Services';

// actions
import * as Actions from '../actions';

// models
import { PaymentImputation } from '../../models/Entities/CashFlow/Payment/PaymentImputation';
import { NewPaymentImputation } from '../../models/Entities/CashFlow/Payment/NewPaymentImputation';
import { ISimpleResult } from '../../models/HttpResult';

type KnownAction =
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationsGetAllRequestAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationsGetAllSuccessAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationsGetAllFailureAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationRollbackRequestAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationRollbackSuccessAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationRollbackFailureAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationCreateRequestAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationCreateSuccessAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationCreateFailureAction;

export const actionCreators = {

    GetPaymentImputations: (paymentId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const appState = getState();
        const token = appState.oidc?.user?.access_token ?? '';

        dispatch({
            type: 'CASHFLOW_PAYMENT_IMPUTATIONS_GETALL_REQUEST',
            paymentId
        });

        try {
            const imputations: PaymentImputation[] = await Services.GetPaymentImputations(token, paymentId);
            dispatch({
                type: 'CASHFLOW_PAYMENT_IMPUTATIONS_GETALL_SUCCESS',
                paymentId,
                payload: imputations
            });
        } catch (error: any) {
            dispatch({
                type: 'CASHFLOW_PAYMENT_IMPUTATIONS_GETALL_FAILURE',
                paymentId,
                error
            });
        }
    },

    RollbackPaymentImputation: (imputationId: number, paymentId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const appState = getState();
        const token = appState.oidc?.user?.access_token ?? '';

        dispatch({
            type: 'CASHFLOW_PAYMENT_IMPUTATION_ROLLBACK_REQUEST',
            imputationId
        });

        try {
            const result: ISimpleResult = await Services.RollbackPaymentImputation(token, imputationId);
            dispatch({
                type: 'CASHFLOW_PAYMENT_IMPUTATION_ROLLBACK_SUCCESS',
                imputationId,
                paymentId,
                payload: result
            });
        } catch (error: any) {
            dispatch({
                type: 'CASHFLOW_PAYMENT_IMPUTATION_ROLLBACK_FAILURE',
                imputationId,
                error
            });
        }
    },

    CreatePaymentImputation: (newImputation: NewPaymentImputation): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const appState = getState();
        const token = appState.oidc?.user?.access_token ?? '';

        dispatch({
            type: 'CASHFLOW_PAYMENT_IMPUTATION_CREATE_REQUEST',
            payload: newImputation
        });

        try {
            const imputation: PaymentImputation = await Services.CreatePaymentImputation(token, newImputation);
            dispatch({
                type: 'CASHFLOW_PAYMENT_IMPUTATION_CREATE_SUCCESS',
                payload: imputation
            });
        } catch (error: any) {
            dispatch({
                type: 'CASHFLOW_PAYMENT_IMPUTATION_CREATE_FAILURE',
                error
            });
        }
    }
};
